// src/contexts/AuthContext.jsx
import { createContext, useContext, useEffect, useState } from "react";
import { getStoredCompany, clearSession, storeTokens, clearTokens, authAPI, deviceAPI, getDeviceId } from "../services/api";
// import { useRouter } from "../contexts/RouterContext";


const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [company, setCompany] = useState(null);
  const [loading, setLoading]  = useState(true);
  // const {navigate} = useRouter();

  // Restore session from sessionStorage on page load
  useEffect(() => {
    try {
      const stored = getStoredCompany();
      if (stored?.CM_Id) setCompany(stored);
    } catch (e) {
      console.error("[AuthContext] restore error:", e);
    } finally {
      setLoading(false);
    }
  }, []);

  // Called by LoginOTP screen and RegisterScreen after success
  // const loginWithCompany = (companyData) => {
  //   sessionStorage.setItem("oms_company", JSON.stringify(companyData));
  //   setCompany(companyData);
  // };

   const loginWithCompany = (companyData) => {
    sessionStorage.setItem(
      "oms_company",
      JSON.stringify(companyData)
    );

    setCompany(companyData);
  };

  // Merge a patch into the company object and persist it. Used by the Company Profile
  // page after an edit so the sidebar / top bar / printed receipts reflect changes
  // immediately without a reload. Forces CM_Id (the key the session-restore guard reads)
  // so a backend echo that only carries CM_ID can't silently log the user out.
  const updateCompany = (patch) => {
    setCompany((prev) => {
      const merged = { ...(prev ?? {}), ...patch };
      merged.CM_Id = merged.CM_Id ?? merged.CM_ID ?? prev?.CM_Id;
      sessionStorage.setItem("oms_company", JSON.stringify(merged));
      return merged;
    });
  };

  // Re-fetches the company record from the server and updates both
  // sessionStorage and state in place. Used after a successful key
  // activation so the lock screen can lift without a hard reload.
  const refreshCompany = async () => {
    try {
      const deviceId = await getDeviceId();
      const res = await deviceAPI.checkRegistration(deviceId);

      if (res.status === "success" && res.data?.CM_Id) {
        sessionStorage.setItem("oms_company", JSON.stringify(res.data));
        setCompany(res.data);
        return res.data;
      }
    } catch (e) {
      console.error("[AuthContext] refreshCompany error:", e);
    }
    return null;
  };

  // ✅ LOGOUT WITH API
 const logout = async () => {
      try {

        // ✅ CALL LOGOUT API
        const response = await authAPI.logout({
          device_id: company?.device_id,
        });

        console.log("Logout Response:", response);

        // ✅ ONLY CLEAR IF SUCCESS
        if (response?.status === "success") {

          // CLEAR STORAGE
          clearSession();

          sessionStorage.clear();
          localStorage.clear();

          // RESET STATE
          setCompany(null);

        } else {

          // ❌ API FAILED — clear locally anyway so the user isn't stuck
          console.warn(response?.message || "Couldn't logout via API. Clearing session locally.");
          clearSession();
          sessionStorage.clear();
          localStorage.clear();
          setCompany(null);
        }

      } catch (e) {

        console.error("[Logout API Error]", e);

        // Network/API failure — still clear locally so the user can
        // get back to the welcome screen instead of being stuck.
        clearSession();
        sessionStorage.clear();
        localStorage.clear();
        setCompany(null);
      }
    };

  return (
    <AuthContext.Provider
      value={{
        company,
        loading,
        loginWithCompany,
        refreshCompany,
        updateCompany,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}


export const useAuth = () => useContext(AuthContext);
